import { InfinitePaginationContext } from "ra-core";

import { Note } from "./Note";
import { NoteCreate } from "./NoteCreate";
import { InfinitePagination } from "../misc/InfinitePagination";
import { useAddInfinitePagination } from "./useAddInfinitePagination";
import type { NoteReference } from "./foreignKeyMapping";

export const NotesIterator = ({
  reference,
  showStatus,
}: {
  reference: NoteReference;
  showStatus?: boolean;
}) => {
  const { infinitePaginationContextValue, isPending, error, data } =
    useAddInfinitePagination();

  if (isPending || error) return null;

  return (
    <InfinitePaginationContext.Provider value={infinitePaginationContextValue}>
      <div className="mt-4">
        <NoteCreate reference={reference} showStatus={showStatus} />
        {data.length && (
          <div className="mt-4 space-y-3">
            {data.map((note, index) => (
              <Note
                note={note}
                isLast={index === data.length - 1}
                key={index}
                showStatus={showStatus}
              />
            ))}
          </div>
        )}
        <InfinitePagination />
      </div>
    </InfinitePaginationContext.Provider>
  );
};
